import { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { routeConfig } from "../../routes/routeConfig";
import { PATHS } from "../../routes/paths";
import AppLayout from "../../layouts/AppLayout/AppLayout";
import Loader from "../../../shared/ui/feedback/Loader/Loader";
import { RequireAuth } from "./guards/RequireAuth";
import { PublicOnly } from "./guards/PublicOnly";
import { RequireRole } from "./guards/RequireRole";

export const AppRouter = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {/* Public routes */}
        {routeConfig
          .filter((r) => r.isPublic)
          .map((r) => (
            <Route
              key={r.path}
              path={r.path}
              element={
                r.path === PATHS.login ? (
                  <PublicOnly>{r.element}</PublicOnly>
                ) : (
                  r.element
                )
              }
            />
          ))}

        <Route
          element={
            <RequireAuth>
              <AppLayout />
            </RequireAuth>
          }
        >
          {routeConfig
            .filter((r) => r.onlyAuth)
            .map((r) => {
              const wrappedElement = r.roles ? (
                <RequireRole roles={r.roles}>{r.element as JSX.Element}</RequireRole>
              ) : (
                r.element
              );

              if (r.children && r.children.length > 0) {
                return (
                  <Route key={r.path} path={r.path} element={wrappedElement}>
                    {r.children.map((child) =>
                      child.path === '' ? (
                        <Route key={`${r.path}-index`} index element={child.element} />
                      ) : (
                        <Route key={child.path} path={child.path} element={child.element} />
                      )
                    )}
                  </Route>
                );
              }

              return (
                <Route key={r.path} path={r.path} element={wrappedElement} />
              );
            })}
        </Route>

        <Route path="*" element={<Navigate to={PATHS.login} replace />} />
      </Routes>
    </Suspense>
  );
};